/**
 * Model Media Custom Element
 * Handles 3D model display in product galleries
 */

if (!customElements.get('model-media')) {
  customElements.define('model-media', class ModelMedia extends HTMLElement {
    constructor() {
      super();
      this.modelViewer = null;
      this.group = this.getAttribute('group') || 'default';
      this.handle = this.getAttribute('handle');
      
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.modelViewer = this.querySelector('model-viewer');
      
      if (this.modelViewer) {
        // Add click handler for interaction
        this.addEventListener('click', this.handleClick);
        this.style.cursor = 'pointer';
        
        // Set up model viewer attributes
        this.setupModelViewer();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    setupModelViewer() {
      if (!this.modelViewer) return;
      
      // Ensure model viewer is properly configured
      this.modelViewer.setAttribute('interaction-prompt', 'auto');
      this.modelViewer.setAttribute('camera-controls', '');
      this.modelViewer.setAttribute('touch-action', 'pan-y');
      
      // Handle model loading
      this.modelViewer.addEventListener('load', () => {
        this.classList.add('loaded');
      });
      
      this.modelViewer.addEventListener('error', () => {
        console.warn('Model failed to load');
        this.classList.add('error');
      });
    }

    handleClick() {
      // Focus the model viewer for interaction
      if (this.modelViewer) {
        this.modelViewer.focus();
      }
    }
  });
}
